import { type AnyFormApi, useSelector } from '@tanstack/react-form';
import { useState } from 'react';
import type { FormProps } from '../components/ui/form/types';

export function useFormProps(form: AnyFormApi): FormProps {
  const isDirty = useSelector(form.store, (state) => state.isDirty);
  const isDefaultValue = useSelector(form.store, (state) => state.isDefaultValue);
  const isSubmitting = useSelector(form.store, (state) => state.isSubmitting);

  // if the navigation is slow, lock the submission
  const [succeeded, setSucceeded] = useState<boolean>(false);

  return {
    onSubmit: async () => {
      if (succeeded) {
        return;
      }
      form.setErrorMap({ onSubmit: { fields: {} } });

      try {
        await form.handleSubmit();
      } catch {
        // handleSubmit rethrows errors to be caught here
        return;
      }

      // Read from `form.state` for render time check
      if (form.state.isSubmitSuccessful) {
        setSucceeded(true);
        // keepDefaultValues is required as it doesn't re-apply the original options when resetting
        form.reset(form.state.values, { keepDefaultValues: true });
      }
    },
    onReset: () => form.reset(),
    isDirty: !succeeded && isDirty && !isDefaultValue,
    loading: isSubmitting,
  };
}
